module.exports = __webpack_public_path__ + "static/media/vf_wshoes_core.084747be.svg";